import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Icon from "../../controls/Icons/Icon";
import { Row, Col, Form, Spinner, Card, Button, Table, Modal, CloseButton } from "react-bootstrap";
import ErrorHandler from "../../controls/ErrorHandler";
import { ErrorBoundary } from 'react-error-boundary';
import { dateDisplayFormater } from "../../../Utils";
//import useFetchWithCancellation from '../../customhooks/useFetchWithCancellation';
import useFetchWithCancellation from '../../../customhooks/useFetchWithCancellation';
import { useEffect } from 'react';
import { useRef } from 'react';
export default function Mnureports() {
    const state = useSelector(state => state);
    const formRef = useRef();
    const { fetchData } = useFetchWithCancellation();
    const [validated, setValidated] = useState(false);
    const [data, setData] = useState({
        fkInvoiceId: 0,
        User: "",
        UserId: 0,
        CreatedDate: new Date(),
        Notes: "",
    });

    useEffect(() => {
        if (state.invIDNote > 0) {
            var loggedInUser = JSON.parse(localStorage.getItem("user"));
            setData(dat => ({ ...dat, fkInvoiceId: state.invIDNote, User: loggedInUser.name, UserId: loggedInUser.Id }));
        }
    }, []);
    const handleChange = (e) => {
        let value = e.target.value;
        let name = e.target.name;
        if (e.target.value) {
            setData(d => ({ ...d, [name]: value }));
        }
    }

    const SaveData = () => {

        if (data && data.fkInvoiceId > 0) {

            let obj = new Object();
            obj.fkInvoiceId = data.fkInvoiceId;
            obj.Notes = data.Notes;
            obj.CreatedBy = data.UserId;
            obj.ModifiedBy = data.UserId;
            // obj.isActive = 1;

            fetchData(state.projectdetail.API + "/invoiceNotes/Save", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(obj)
            }).then(response => response.json()).then((res) => {
                if (res.Succeeded) {
                    res.Data.CreatedDate = new Date(res.Data.CreatedDate);
                    setData(res.Data);
                    window.toast("Invoice saved sucessfully");
                    setValidated(false);
                    // setSavedSuccessfully(true);

                }
                else {
                    window.alert(res.Message, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                }
            }).catch((err) => {
                if (err && err.name === 'AbortError') return;
                window.HandleError("PCPInvoiceNotes.js ==> Invoice notes save", null, null, err);
                window.alert(state.projectdetail.ErrorMessage);
            }).finally(() => {
                // setLoading(false);
                // dispatch({ type: UpdtInvoiceContAction.ClearInvoiceContent });
            });

        }
    }
    const [showAddNotes, setShowAddNotes] = useState(false);
    const AddNotes = () => {
        setShowAddNotes(true);
    }
    return (<ErrorBoundary FallbackComponent={ErrorHandler}>
        <Form noValidate validated={validated} ref={formRef}>
            <div>   
                <p style={{color:'white',textAlign:'center', fontSize:20} }> Page development is in progress</p>
                {/*<div>*/}
                {/*    Invoice Notes Screen : {state.invIDNote}*/}
                {/*</div>*/}
                {/*<Row>*/}
                {/*    <Col>*/}
                {/*        <Card className="border">*/}
                {/*            <Card.Body>*/}
                {/*                <Row md={12}>*/}
                {/*                    <Col md={6}>*/}
                {/*                        <div><Form.Group>*/}
                {/*                            <Form.Label>User:</Form.Label>*/}
                {/*                            <Form.Control type="text" name="User" value={data.User} disabled autoComplete="off" />*/}
                {/*                        </Form.Group></div>*/}
                {/*                    </Col>*/}
                {/*                    <Col md={3}></Col>*/}
                {/*                    <Col md={3}>*/}
                {/*                        <div><Form.Group>*/}
                {/*                            <Form.Label>Date:</Form.Label>*/}
                {/*                            <Form.Control type="text" name="CreatedDate" value={dateDisplayFormater(data.CreatedDate)} disabled autoComplete="off" />*/}
                {/*                        </Form.Group></div>*/}
                {/*                    </Col>*/}
                {/*                </Row>*/}
                {/*                <Row>*/}
                {/*                    <Col md={10}></Col>*/}
                {/*                    <Col md={2}>*/}
                {/*                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*/}
                {/*                        &nbsp;&nbsp;&nbsp;*/}
                {/*                        <Button variant="primary"*/}
                {/*                            style={{ align: 'left' }}*/}
                {/*                            onClick={AddNotes}>*/}
                {/*                            Save*/}
                {/*                        </Button>*/}
                {/*                    </Col>*/}

                {/*                </Row>*/}
                {/*                {showAddNotes && (*/}
                {/*                    <Row>*/}
                {/*                        <Col md={12}>*/}
                {/*                            <Form.Group>*/}
                {/*                                <Form.Label>Notes<code className='required-symbol'></code></Form.Label>*/}
                {/*                                <Form.Control as="textarea" rows={10} name="Notes" onChange={(e) => { handleChange(e) }}*/}
                {/*                                    value={data.Notes} autoComplete="off" placeholder="Enter notes here..." />*/}
                {/*                            </Form.Group>*/}
                {/*                        </Col>*/}
                {/*                    </Row>)}*/}
                {/*                <Row>*/}
                {/*                    <p></p>*/}

                {/*                </Row>)}*/}
                {/*                {showAddNotes && (*/}
                {/*                    <Row>*/}
                {/*                        <Col md={10}></Col>*/}
                {/*                        <Col md={2}>*/}
                {/*                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*/}
                {/*                            &nbsp;&nbsp;&nbsp;*/}
                {/*                            <Button variant="primary"*/}
                {/*                                style={{ align: 'left' }}*/}
                {/*                                onClick={SaveData}>*/}
                {/*                                Save*/}
                {/*                            </Button>*/}
                {/*                        </Col>*/}
                {/*                    </Row>)*/}
                {/*                }*/}
                {/*            </Card.Body>*/}
                {/*        </Card>*/}
                {/*    </Col>*/}
                {/*</Row>*/}
            </div>
        </Form>
    </ErrorBoundary>
    )

}